export function TermsVersion1() {
  return (
    <>
      <p>
        Track
        アカウント利用規約（以下、「本規約」といいます）は、株式会社ギブリー（以下、「当社」といいます）が提供する「Track
        アカウントサービス」（第1条第2号に定義するものをいいます）を利用するにあたってユーザー（第1条第3号に定義するものをいいます）及び登録希望者（第3条第1項）に同意していただく必要のある事柄を記載しています。
      </p>

      <p>
        Track
        アカウントサービスをご利用になる際には、本規約が適用されます。なお、本規約については、登録希望者が利用登録した時点で同意されたものとさせていただきますので、ご利用の前に必ずお読みください。
      </p>

      <section>
        <h2>第1条 （定義）</h2>
        <p>
          本規約において使用する用語は、次の各号に定める意味を有するものとします。
        </p>
        <ul className="list-none" role="presentation">
          <li>
            <ol>
              <li>
                「Track アカウント」とは、当社の提供する「Track」シリーズ（
                <a
                  href="https://tracks.run/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://tracks.run/
                </a>
                ）をユーザーが利用するにあたり、共通で利用可能な管理者用アカウントを指します。
              </li>
              <li>
                「Track アカウントサービス」とは、Track
                アカウントを用いた「Track」シリーズにおける管理者用ログイン認証サービスのことをいいます。Track
                アカウントサービスの対象となる「Track」シリーズの詳細については、当社指定のWebページをご確認ください。なお、各「Track」シリーズを利用する場合、別途各サービスの利用契約の締結及び利用規約への同意が必要となります。
              </li>
              <li>
                「ユーザー」とは、第3条に基づき登録を行った個人をいいます。
              </li>
              <li>
                「知的財産権」とは、著作権、特許権、実用新案権、商標権、意匠権（これらの権利を取得し、又はこれらの権利につき登録等を出願する権利を含みます）又はアイデア、ノウハウ等をいいます。
              </li>
              <li>
                「連携サービス」とは、当社がAPI連携等を行っている、本サービスの仕様上必要となる他の事業者が提供するサービスをいいます。
              </li>
              <li>
                「外部サービス」とは、ユーザー又はユーザーの所属する企業が契約した他の事業者が提供するサービスであって、当社が本サービスとの連携を認めたサービスをいいます。
              </li>
            </ol>
          </li>
        </ul>
      </section>

      <section>
        <h2>第2条 （目的）</h2>
        <ol>
          <li>
            本規約は、ユーザーがTrack
            アカウントサービスを利用するに際して、遵守していただく事項及び利用方法、利用条件等を定めたものです。
          </li>
          <li>
            ユーザーは、本規約を理解し、その内容のすべてについて同意した上でTrack
            アカウントサービスを利用するものとし、また、Track
            アカウントサービスの利用にあたっては、本規約を遵守しなければなりません。
          </li>
          <li>
            ユーザーがTrack
            アカウントサービスの利用を開始したときは、ユーザーは、本規約を理解したうえで、その内容のすべてについて同意したものとみなされます。
          </li>
          <li>
            本規約に規定していないTrack
            アカウントサービスの利用条件の詳細については、当社が別途定めるものとします。
          </li>
        </ol>
      </section>

      <section>
        <h2>第3条 （ユーザー登録）</h2>
        <ol>
          <li>
            Track
            アカウントサービスの利用を希望する者（以下、「登録希望者」といいます）は、本規約に同意し、かつ当社の定める一定の情報（以下、「登録事項」といいます）を当社の定める方法で当社に提供することにより、Track
            アカウントサービスの利用登録をすることができます。なお、登録希望者は、当社に対し、登録事項を提供するにあたり、正確かつ最新の情報を提供することを保証します。
          </li>
          <li>
            前項に定める登録時に、当社とユーザーの間にTrack
            アカウントサービスに関する利用契約（以下、「利用契約」といいます）が成立するものとし、ユーザーは利用契約の成立以降、Track
            アカウントサービスを利用することができるようになります。
          </li>
          <li>
            <p>
              当社は、登録希望者が、以下の各号のいずれかの事由に該当する場合は、登録の取消し又は再登録を拒否することがあり、その理由について一切開示義務を負いません。また、当社は、登録希望者の登録の取消し又は再登録の拒否について、一切の責任を負いません。
            </p>
            <ol>
              <li>
                当社に提供した登録事項の全部又は一部につき虚偽（次のような場合が含まれますがこれらに限られません）、誤記又は記載漏れがあった場合
                <ol>
                  <li>他人の情報を提供する行為</li>
                  <li>虚偽の登録事項を提供する行為</li>
                  <li>登録事項の項目に対し、不適切な情報を記載する行為</li>
                </ol>
              </li>
              <li>
                反社会的勢力等（暴力団、暴力団員、右翼団体、反社会的勢力、その他これに準じる者を意味します。以下同様です）である、又は資金提供その他を通じて反社会的勢力等の維持、運営もしくは経営に協力もしくは関与する等反社会的勢力等との何らかの交流もしくは関与を行っていると当社が判断した場合
              </li>
              <li>
                過去当社との契約に違反した者又はその関係者であると当社が判断した場合
              </li>
              <li>第9条に定める登録抹消等の措置を受けたことがある場合</li>
              <li>
                その他、当社がTrack
                アカウントサービスを利用させることを相当でないと判断した場合
              </li>
            </ol>
          </li>
          <li>
            ユーザーがTrack
            アカウントサービスに登録している情報はすべて、ユーザー自らがその内容について責任を負うものとします。
          </li>
          <li>
            ユーザーは、登録事項が常に正確かつ最新であることを確認し、登録事項に変更があった場合、当該変更事項を遅滞なく当社に通知するものとします。
          </li>
        </ol>
      </section>

      <section>
        <h2>第4条 （ID等の管理）</h2>
        <ol>
          <li>
            ユーザーは、Track
            アカウントサービスの利用に必要なID及びパスワード等（以下「ID等」といいます）を自己の責任において管理及び保管するものとし、盗難、紛失、不正使用及び第三者による無断使用等があった場合においても、当社はそれらの損害について一切の責任を負いません。また、当社はユーザーのID等が用いられた場合、当該ユーザーによる利用とみなし、ユーザーは、自己のID等を利用してなされた一切の行為及びその結果について、理由の如何を問わず、その責任を負うものとします。
          </li>
          <li>
            ユーザーは、ID等を第三者に利用させ、又は貸与、譲渡、名義変更、売買等をしてはならないものとします。
          </li>
          <li>
            ユーザーは、ID等の盗難、漏洩があった場合、ID等を失念した場合又はID等がユーザーの意に反して第三者に使用されていることが疑われる場合には、直ちに当社にその旨を連絡し、当社の指示に従うものとします。
          </li>
        </ol>
      </section>

      <section>
        <h2>第5条 （Track アカウントサービスの利用）</h2>
        <p>
          ユーザーは、本規約の目的の範囲内でかつ本規約に違反しない範囲内で、当社の定める方法に従い、Track
          アカウントサービスを利用することができるものとします。
        </p>
      </section>

      <section>
        <h2>第6条 （情報等の取り扱い）</h2>
        <ol>
          <li>
            <p>
              当社は、Track
              アカウントサービスをユーザーに提供するにあたり、ユーザーが登録した情報その他ユーザーによる本サービスの利用記録等（以下、「情報等」という）を、以下の利用目的に必要な範囲内で閲覧又は利用することがあることとし、ユーザーは予めこれを承諾するものとします。
            </p>
            <ol>
              <li>ユーザーの同一性確認のため</li>
              <li>各「Track」シリーズにおいてユーザーを認証するため</li>
              <li>
                各「Track」シリーズ間において当該ユーザーの情報等を相互に連携するため
              </li>
              <li>
                Track
                アカウントサービス及び当社が提供するサービスに関する案内のため
              </li>
              <li>
                Track アカウントサービスに関する問い合わせ等への対応のため
              </li>
              <li>
                前各号に付随するTrack
                アカウントサービス並びに各「Track」シリーズの提供、維持、改善、開発のため
              </li>
            </ol>
          </li>
          <li>
            ユーザーは、当社が、ユーザー情報の情報主体である個人が特定できない情報及びTrack
            アカウントサービスの利用状況、またはこれらの情報を基に当社が作成した統計データ、分析データについて、ウェブサイト、新聞、雑誌、書籍その他の各種媒体に掲載又は転載し、または当社のその他の事業活動に利用することを承諾するものとします。
          </li>
          <li>
            ユーザーは、当社が、システム等の保守、点検ないし管理のため、当社と業務委託契約を締結する企業に対し、当該企業との間で予め個人情報及び機密情報の保護についての契約を締結した上で、Track
            アカウントサービスに関わる一切の情報を開示することを承諾するものとします。
          </li>
          <li>
            当社は、Track
            アカウントサービスに係る業務の全部または一部を委託した第三者に対し、委託の目的を達成するために必要な限度で、機密情報及び個人情報を含むユーザーに関する情報を当該第三者に対して提供することができるものとし、ユーザーは予めこれを承諾するものとします。
          </li>
          <li>
            当社は、連携サービス及び外部サービスと連携する場合があり、連携サービス及び外部サービスとの連携及びその他合理的な範囲内において当該連携サービス及び外部サービスの提供元にユーザーの情報等を提供することがあるものとし、ユーザーは予めこれを承諾するものとします。なお、連携サービス及び外部サービスに連携されるデータについては、当該連携サービス及び外部サービスのデータポリシー及びプライバシーポリシーに従い取り扱われるものとし、当社は一切の責任を負わないものとします。
          </li>
          <li>
            当社は、連携サービス及び外部サービスとの連携について、かかる連携を保証するものではなく、本サービスの利用に関して連携サービス及び外部サービスと連携できなかった場合であっても、当社は、これによってユーザーに生じた損害等について、当社の故意又は重過失の場合を除き一切責任を負いません。
          </li>
          <li>
            ユーザーは、連携サービス及び外部サービス利用規約を遵守するものとします。
          </li>
          <li>
            ユーザー若しくは当社が外部サービス事業者からクレームを受け、又はユーザー若しくは当社と外部サービス事業者との間で紛争が生じた場合であっても、当社は、当該クレームや紛争等について、当社の故意又は重過失の場合を除き、一切責任を負いません。この場合、ユーザーは、自己の責任と費用において（当該外部サービスがユーザーの所属する企業の契約するサービスである場合は当該企業と連帯してその責任と費用において）当該クレーム又は紛争を処理解決するものとし、当社に何らの損害も与えないよう当社を防御免責するものとします。
          </li>
          <li>
            ユーザーは、本サービスと連携する連携サービス及び外部サービスの利用規約又は運用方針の変更等に伴い、本サービスの一部又は全部の利用が制限される可能性があることを予め了承するものとし、当社はこれにより生じた損害について一切の責任を負いません。
          </li>
          <li>
            前各項に定めるほか、当社がTrack
            アカウントサービスを通じて取得した情報の取扱いについては、当社が別途定める「プライバシーポリシー（
            <a
              href="https://givery.co.jp/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://givery.co.jp/privacy-policy/
            </a>
            ）」に従うものとします。ユーザーは、本サービスの利用に先立ち、必ず「プライバシーポリシー（
            <a
              href="https://givery.co.jp/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://givery.co.jp/privacy-policy/
            </a>
            ）」を読み、十分に内容をご確認いただいたうえで、本サービスをご利用いただくものとします。
          </li>
        </ol>
      </section>

      <section>
        <h2>第7条 （禁止事項）</h2>
        <p>
          ユーザーは、Track
          アカウントサービスの利用にあたり、次の各号に該当する行為、又は該当するおそれのある行為を自ら行ってはなりません。
        </p>
        <ul className="list-none" role="presentation">
          <li>
            <ol>
              <li>法令に違反する行為又は犯罪行為に関する行為</li>
              <li>
                当社、Track
                アカウントサービスの他のユーザー又はその他の第三者に対する詐欺又は脅迫行為
              </li>
              <li>公序良俗に反する行為</li>
              <li>
                当社、Track
                アカウントサービスの他のユーザー又はその他の第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利用を侵害する行為
              </li>
              <li>
                <p>
                  Track
                  アカウントサービスを通じ、以下に該当し、又は該当すると当社が判断する情報を当社又はTrack
                  アカウントサービスの他のユーザーに送信すること
                </p>
                <ul>
                  <li>過度に暴力的又は残虐な表現を含む情報</li>
                  <li>
                    コンピューターウイルスその他の有害なコンピュータープログラムを含む情報
                  </li>
                  <li>
                    当社、Track
                    アカウントサービスの他のユーザー又はその他の第三者の名誉・信用を毀損する表現を含む情報
                  </li>
                  <li>過度にわいせつな表現を含む情報</li>
                  <li>差別を助長する表現を含む情報</li>
                  <li>自殺、自傷行為を助長する表現を含む情報</li>
                  <li>薬物の不適切な利用を助長する表現を含む情報</li>
                  <li>反社会的な表現を含む情報</li>
                  <li>チェーンメール等の第三者への情報の拡散を求める情報</li>
                  <li>他人に不快感を与える表現を含む情報</li>
                  <li>面識のない異性との出会いを目的とした情報</li>
                </ul>
              </li>
              <li>
                Track
                アカウントサービスにより提供されるソフトウェアの全部または一部に対し、リバースエンジニアリング、逆コンパイル、逆アセンブル、修正、改変または派生ソフトウェアを作成する行為
              </li>
              <li>
                Track
                アカウントサービスのネットワーク又はシステム等に過度に負荷をかける行為
              </li>
              <li>Track アカウントサービスの運営を妨害するおそれのある行為</li>
              <li>
                Track
                アカウントサービスの他のユーザー又はその他の第三者に登録事項として虚偽情報を提供するようあっせんする行為
              </li>
              <li>
                当社のネットワーク又はシステム等に不正にアクセスし、又は不正なアクセスを試みる行為
              </li>
              <li>ID等を不正に使用する行為</li>
              <li>
                自己もしくは他のユーザーのID等を第三者に利用させ、又は貸与、譲渡、名義変更、売買等する行為
              </li>
              <li>
                当社が事前に許諾しないTrack
                アカウントサービス上での宣伝、広告、勧誘、又は営業行為
              </li>
              <li>Track アカウントサービスの他のユーザーの情報の収集</li>
              <li>
                当社、Track
                アカウントサービスの他のユーザー又はその他の第三者に不利益、損害、不快感を与える行為
              </li>
              <li>
                反社会的勢力等への利益供与、反社会的勢力等との交流又は関与
              </li>
              <li>面識のない異性との出会いを目的とした行為</li>
              <li>前各号の行為を直接又は間接に惹起し、又は容易にする行為</li>
              <li>その他、当社が不適切と判断する行為</li>
            </ol>
          </li>
        </ul>
      </section>

      <section>
        <h2>第8条 （権利帰属）</h2>
        <p>
          Track
          アカウントサービスに関する知的財産権はすべて当社又は当社にライセンスを承諾している者に帰属しており、当社又は当社にライセンスを承諾している者を除き、方法又は形態の如何を問わず、これを当社に無断で複製、複写、転載、転送、蓄積、販売、出版、その他Track
          アカウントサービスの利用契約の範囲を超えて使用してはならないものとします。
        </p>
      </section>

      <section>
        <h2>第9条 （登録抹消等）</h2>
        <p>
          当社は、ユーザーが、以下の各号のいずれかの事由に該当する場合は、事前に通知又は催告することなく、当該ユーザーについてTrack
          アカウントサービスの利用を一時的に停止し、又はユーザーとしての登録を抹消し、もしくは利用契約を解除することができます。当社は、本条に基づき当社が行った行為によりユーザーに生じた損害について一切の責任を負いません。なお、本条に基づき当社が行った行為は、その他損害賠償の請求等を妨げるものではなく、ユーザーに対する法的措置の検討及び実施（損害賠償請求権の行使も含みますが、これに限られません）を行う場合がございます。
        </p>
        <ul className="list-none" role="presentation">
          <li>
            <ol>
              <li>本規約のいずれかの条項に違反した場合</li>
              <li>登録事項に虚偽の事実があることが判明した場合</li>
              <li>
                当社からの問い合わせその他の回答を求める場合に対して、60日間以上応答がない場合
              </li>
              <li>
                その他、当社がTrack
                アカウントサービスの利用、ユーザーとしての登録を適当でないと判断した場合
              </li>
            </ol>
          </li>
        </ul>
      </section>

      <section>
        <h2>第10条 （Track アカウントサービスの利用停止等）</h2>
        <ol>
          <li>
            当社は、Track
            アカウントサービスに係るコンピュータシステムの点検又は保守作業等を行うためにTrack
            アカウントサービスの全部又は一部の提供を一時的に停止又は中断できるものとします。
          </li>
          <li>
            <p>
              前項にかかわらず、当社は、以下のいずれかに該当する場合には、ユーザーに事前に通知することなく、Track
              アカウントサービスの全部又は一部の提供を停止又は中断することができるものとします。
            </p>
            <ol>
              <li>
                Track
                アカウントサービスに係るコンピュータシステムの点検又は保守作業を緊急で行う場合
              </li>
              <li>コンピュータ、通信回線等が事故等により停止した場合</li>
              <li>
                地震、落雷、火災、風水害、停電、天災地変などの不可抗力によりTrack
                アカウントサービスの運営ができなくなった場合
              </li>
              <li>その他、当社が停止又は中断を必要と判断した場合</li>
            </ol>
          </li>
          <li>
            当社は、本条に基づき当社が行った措置に基づきユーザーに生じた損害について一切の責任を負いません。
          </li>
        </ol>
      </section>

      <section>
        <h2>第11条 （Track アカウントサービスの内容の変更、終了）</h2>
        <ol>
          <li>
            当社は、当社の都合により、Track
            アカウントサービスの内容を変更し、又は提供を終了することができます。当社がTrack
            アカウントサービスの提供を終了する場合、当社は当社の定める方法により、ユーザーに事前に通知するものとします。
          </li>
          <li>
            当社は、本条に基づき当社が行った措置に基づきユーザーに生じた損害について、当社の責に帰すべき事由による場合を除き、一切の責任を負わないものとします。
          </li>
        </ol>
      </section>

      <section>
        <h2>第12条 （保証の否認及び免責）</h2>
        <ol>
          <li>
            当社は、Track アカウントサービスを現状のまま提供するものとし、Track
            アカウントサービスがユーザーの特定の目的に適合すること、期待する機能、商品的価値、正確性及び有用性を有すること、ユーザーによるTrack
            アカウントサービスの利用がユーザーに適用のある法令又は業界団体の内部規約等に適合すること、及び不具合が生じないことについて、何ら保証するものではありません。
          </li>
          <li>
            当社は、当社によるTrack
            アカウントサービスの提供の中断、停止、終了、利用不能又は変更、ユーザーがTrack
            アカウントサービスに送信したメッセージ又は情報の削除又は消失、ユーザーの登録の抹消、Track
            アカウントサービスの利用による登録データの消失又は機器の故障もしくは損傷、その他Track
            アカウントサービスに関してユーザーが被った損害については、当社の故意又は重過失による場合を除き、一切の責任を負わないものとします。
          </li>
          <li>
            ユーザーは自らの責任においてTrack
            アカウントサービスを利用するものとし、当社は、ユーザーがTrack
            アカウントサービスを利用したことにより、第三者との間において発生した紛争及び損害について、一切責任を負いません。
          </li>
        </ol>
      </section>

      <section>
        <h2>第13条 （損害賠償）</h2>
        <p>
          本規約で別途定める場合を除き、当社が故意または重過失により、本規約の義務に違反してお客様に損害を与えた場合、当社は、ユーザーに対し、その直接かつ通常の現実損害について損害賠償責任を負うものとします。なお、かかる損害賠償責任は、当該損害発生の直接の原因となった利用契約所定の対価相当額を上限とします。
        </p>
      </section>

      <section>
        <h2>第14条 （権利義務の譲渡等の禁止）</h2>
        <ol>
          <li>
            ユーザーは、本契約について、その契約上の地位及びこれにより生じる権利義務の全部又は一部を、当社の書面による事前の承諾なく第三者に譲渡等の処分をし、引き受けさせ、又は担保に供することはできません。
          </li>
          <li>
            当社がTrack
            アカウントサービスに係る事業を第三者に譲渡した場合には、当該事業譲渡に伴い本契約上の地位、権利及び義務並びにTrack
            アカウントサービスを通じて当社が取得した情報を、当該事業譲渡の譲受人に譲渡することができるものとし、ユーザーは、かかる譲渡につき予め同意するものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。
          </li>
        </ol>
      </section>

      <section>
        <h2>第15条 （通知等）</h2>
        <ol>
          <li>
            ユーザーから当社に対する通知又は連絡（以下、「通知等」といいます）、及び当社からユーザーに対する通知等は、特に定めのない限り、電子メールその他当社の定める方法で行うものとします。
          </li>
          <li>
            当社が行うユーザーへの通知等の効力は、当社が当該通知等を発信した時点をもって発生するものとし、それ以外の方法を用いる場合、当該通知等の効力は、当該通知等がユーザーに到達するために合理的に必要な期間が経過した時点で発生するものとします。
          </li>
          <li>
            前項に定める通知の効力は、ユーザーが現実に通知等を受領し又は認識したかを問わず発生するものとします。
          </li>
        </ol>
      </section>

      <section>
        <h2>第16条 （本規約等の変更）</h2>
        <ol>
          <li>
            当社は、本規約を任意に変更できるものとします。本規約を変更する場合、当社は、変更後の利用規約（以下、変更後の利用規約を「新規約」といいます）の効力発生時期を定め、かつ、本規約を変更する旨、新規約の内容、及びその効力発生時期を当社ウェブサイトに掲示する等、適切な方法で周知するものとします。
          </li>
          <li>
            当該周知後、ユーザーが本サービスを利用した場合には、ユーザーは、本規約の変更に同意したものとみなされます。
          </li>
        </ol>
      </section>

      <section>
        <h2>第17条 （分離可能性）</h2>
        <p>
          本規約のいずれかの条項またはその一部が、管轄権を有する裁判所により、違法、無効、または執行不能とされた場合においても、残存部分についてはなお有効に存続します。また、残存部分について、当該条項もしくは部分の趣旨に最も近い有効な条項を無効な条項もしくは部分と置き換えて適用し、または当該条項もしくは部分の趣旨に最も近い有効な条項となるよう合理的な解釈を加えて適用します。
        </p>
      </section>

      <section>
        <h2>第18条 （準拠法及び管轄裁判所）</h2>
        <p>
          本規約及び利用契約の準拠法は日本法とし、本規約に起因し、又は関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
        </p>
      </section>

      <section>
        <h2>第19条 （協議解決）</h2>
        <p>
          本規約に定めのない事項又は本規約の解釈に疑義が生じた場合には、互いに信義誠実の原則に従って協議の上、速やかに解決を図るものとします。
        </p>
      </section>

      <p>以上</p>
      <p>2026年8月17日 制定</p>
    </>
  );
}
